export { default, loader } from "/tmp/build/apps/asap/src/routes/auth/login.tsx";